<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<p class="dedi1">For Abram Sohmer and Millie Braunstein Sohmer, the light that never failed</p>
<a id="page_vii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication2.vue?5accc6b2